/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {BaseComponent} from 'compob2b-libs';
import {SimpleState} from '../interfaces/SimpleState';
import {AuthStateService} from '../services/auth-state.service';
import {AuthService} from '../services/auth.service';

@Component({
  selector: 'lib-sign-in',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export abstract class SignInComponent extends BaseComponent implements OnInit {

  loginForm = new UntypedFormGroup({
    login: new UntypedFormControl('', [Validators.required, Validators.minLength(4)]),
    password: new UntypedFormControl('', [Validators.required, Validators.minLength(6)]),
    remember: new UntypedFormControl(false)
  });
  state: SimpleState;

  constructor(private readonly userService: AuthService,
              private readonly stateService: AuthStateService) {
    super();
  }

  ngOnInit() {
    this.state = this.stateService.getState();
  }

  onSubmit(): void {
    if (this.loginForm.valid) {
      this.userService.signIn(this.loginForm.value).subscribe(_ => this.afterSignIn());
    }
  }

  afterSignIn(): void {
  }
  //
  // get getError(): string {
  //     <div class="alert alert-danger" *ngIf="(state.get('serverError') | async) === true" i18n>Возникла ошибка. Попробуйте позднее</div>
  //     <div class="alert alert-danger" *ngIf="(state.get('lockedError') | async) === true" i18n>Временная блокировка. Вы ввели неверные данные 5 раз. Попробуйте позднее</div>
  //     <div class="alert alert-danger" i18n *ngIf="(state.get('status') | async) === 403">Неверный логин или пароль</div>
  // }


}
